module.exports = __webpack_public_path__ + "img/bg_profiles.2c425f6d.png";